<template>
  <div>
    <slot :openNav="openNav" :closeNav="closeNav" :activeMenu="activeMenu" :setActiveClass="setActiveClass" :removeActiveClass="removeActiveClass"/>
  </div>
</template>

<script>
  import { toggleActiveClass } from '@Foundation/mixins/toggleActiveClass';
  import { removePageScroll } from '@Foundation/mixins/removePageScroll';
  import { checkScreenSize } from '@Foundation/mixins/checkScreenSize';

  export default {
    name: 'mega-menu',

    mixins: [toggleActiveClass, removePageScroll, checkScreenSize],

    props: {
      hideMenu: { type: Boolean, default: true }
    },

    data() {
      return {
        activeMenu: null,
      };
    },

    watch: {
      hideMenu(value) {
        value && this.closeNav();
        value && this.removeActiveClass();
      }
    },

    mounted() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();

      if (this.screenSize === 'large') {
        this.activeBrand();
      }
    },

    destroyed() {
      window.removeEventListener('resize', this.handleResize);
    },

    methods: {
      handleResize() {
        const isMobile = window.innerWidth <= 1024;
        const headerEventName = isMobile ? 'burger menu' : 'header';
        this.setAttributes(headerEventName);
      },

      setAttributes(eventName) {
        const selectors = [
          'ul.mega-menu__level-1 li.mega-menu__level-1-item ul.mega-menu__level-2-list li.li_DE1 a.a_DE1',
          'ul.mega-menu__level-1 li.mega-menu__level-1-item ul.mega-menu__level-2-list li.li_DE2 button.b_DE2',
          'ul.mega-menu__level-1 li.mega-menu__level-1-item ul.mega-menu__level-2-list li.li_DE2 div.d_DE1 ul.ul_DE1 li.li_DE3 a.a_DE5',
          'ul.mega-menu__level-1 li.mega-menu__level-1-item ul.mega-menu__level-2-list li.li_DE2 div.d_DE1 ul.ul_DE1 li.li_DE4 a.a_DE6',
          'ul.mega-menu__level-1 li.mega-menu__level-1-item ul.mega-menu__level-2-list li.li_DE2 button.b_DE1',
          'ul.mega-menu__level-1 li.mega-menu__level-1-item ul.mega-menu__level-2-list li.li_DE2 a.a_DE2',
        ];

        const setAttributes = (element) => {
          element.setAttribute('data-tag-click_area', eventName);
          element.setAttribute('data-tag-action', `select::${eventName}`);
        };

        selectors.forEach((selector) => {
          const elements = document.querySelectorAll(selector);
          elements.forEach((item) => {
            setAttributes(item);
          });
        });
      },

      openNav(event, menuId) {
        const isClickable = event.target.parentNode.classList.contains('clickable');
        const HasSubitem = event.target.parentNode.querySelector('.mega-menu__level-2');
        if (this.screenSize !== 'large' || event.clientX === 0) {
          if (HasSubitem) {
            if (this.activeMenu === menuId) {
              this.closeNav();
            } else {
              this.activeMenu = menuId;
              this.$emit('menuopen', { open: true, menu: this.activeMenu });
              this.removePageScroll(true);
            }
          } else {
            window.location = event.target.getAttribute('href');
          }
        } else if (isClickable === true) {
          window.location = event.target.getAttribute('href');
        }
      },

      activeBrand() {
        if (this.$el.querySelector('.mega-menu__brand .mega-menu__brand-trigger')) {
          this.$el.querySelector('.mega-menu__brand .mega-menu__brand-trigger').classList.add('active', 'show');
        }
      },

      closeNav(clearBody) {
        this.activeMenu = null;
        this.$emit('menuopen', { open: false, menu: null });
        if (!clearBody && window.matchMedia('(max-width: 1439px)').matches) {
          return false;
        } else {
          this.removePageScroll(false);
        }
      }
    }
  };
</script>

<style lang="scss" src="./mega-menu.scss"></style>
